// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PThunderboltOutlinedSvg from "@fishx/icons-svg/es/asn/PThunderboltOutlined";
import FishxIcon from '../components/FishxIcon';

var PThunderboltOutlined = function PThunderboltOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PThunderboltOutlinedSvg
  }));
};

PThunderboltOutlined.displayName = 'PThunderboltOutlined';
export default React.forwardRef(PThunderboltOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PThunderboltOutlined.js
// module id = 3679
// module chunks = 0